export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Feel Free To Contact Us
          </h2>
          <p className="text-gray-600 mb-8">
            Eirmod sed ipsum dolor sit rebum labore magna erat. Tempor ut dolore
            lorem kasd vero ipsum sit eirmod sit diam justo sed rebum
          </p>
          <button className="px-10 py-4 bg-orange-500 text-white rounded-full font-medium text-lg hover:bg-orange-600 transition-all duration-300 hover:shadow-xl hover:scale-105">
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
}
